let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jNuSK")).then(() => parcelRequire('9Dsnq'));